import React from 'react';
import IconTitleButton from "../buttons/IconTitleButton";
import {IsLP_MP_SP} from "my-styles/media/media";
import SwiperCore, {Scrollbar} from 'swiper/core';
import {Swiper, SwiperSlide} from "swiper/react";
import "swiper/swiper.min.css";
import {Animated} from "react-animated-css";

import ICExpand from '@mui/icons-material/KeyboardArrowDown';

SwiperCore.use([Scrollbar])

export default function ScrollableTitleImage(props) {
    return (<>
        {IsLP_MP_SP() ?
            <div>
                <Swiper
                    direction={'horizontal'}
                    slidesPerView={props.itemsPerView}
                    className="mySwiper">
                    {props.items.map((item, index) => {
                        return <SwiperSlide key={index}>
                            <Animated
                                className="center"
                                animationIn="slideInDown"
                                animationInDuration={400}
                                isVisible={true}>
                                <div className="card marginSmall">
                                    <IconTitleButton
                                        badgenumber={item.badgenumber > 0 ? item.badgenumber : undefined}
                                        width={"100%"}
                                        hover={item.selected ? "var(--pink_1)" : ""}
                                        textcolor={item.selected ? "var(--pink_1)" : ""}
                                        height={item.itemHeight ? item.itemHeight : "8em"}
                                        isvertical={(!props.ishorizontal).toString()}
                                        fontSize="smallTextBold"
                                        icon={<img className="xLargeIcon" src={item.image} alt=""/>}
                                        title={item.title}
                                        onClick={item.onClick}/>
                                </div>
                                {(props.showSelectedItemArrow && item.selected) &&
                                <ICExpand/>
                                }
                            </Animated>
                        </SwiperSlide>
                    })}
                </Swiper>
            </div> :
            <div className="horizontalFullScreen HScroll">
                {props.items.map((item, index) => {
                    return <div key={index} className="center">
                        <div className="card marginSmall">
                            <IconTitleButton
                                badgenumber={item.badgenumber > 0 ? item.badgenumber : undefined}
                                width={props.itemWidth ? props.itemWidth : "100%"}
                                hover={item.selected ? "var(--pink_1)" : ""}
                                textcolor={item.selected === true ? "var(--pink_1)" : ""}
                                height={item.itemHeight ? item.itemHeight : "8em"}
                                isvertical={(!props.ishorizontal).toString()}
                                fontSize="smallTextBold"
                                icon={<img className={props.iconHeight ? props.iconHeight : "xLargeIcon"}
                                           src={item.image} alt=""/>}
                                title={item.title}
                                onClick={item.onClick}/>
                        </div>
                        {(props.showSelectedItemArrow && item.selected) &&
                        <ICExpand/>
                        }
                    </div>
                })}
            </div>
        }
    </>)
}